export default {"src":"https://fishbrain.com/_next/static/media/mapMenuMobileLine.45365338.svg","height":58,"width":1,"blurWidth":0,"blurHeight":0};